export default function ProfileCard({ user, role, image }: { user: string; role: string; image: string }) {
  let nameFormat = user;
  if (user !== undefined) {
    if (nameFormat.includes(',')) {
      const stringArray = user.split(',');
      nameFormat = stringArray[1] + stringArray[0];
    }
  }

  return (
    <figure className='p-4 rounded-md flex bg-white items-center shadow-lg'>
      <img className='w-20 h-20 rounded-full' src={image} alt={role} />
      <div className='space-y-4 ml-5'>
        <figcaption className='text-sm'>
          <p className='font-bold'>{nameFormat}</p>
          <p className='text-sm text-neutralColor-normal'>{role}</p>
        </figcaption>
      </div>
    </figure>
  );
}
